import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getToken, setToken } from '~/features/user/model/slices/user-slice';
import { getCookie } from '~/shared/utils/cookie';
import { useGetUserInfoQuery } from '~/features/user/model/api/users-api';

export const Wrapper: React.FC<any> = ({ children }) => {
  const token = useSelector(getToken);
  const dispatch = useDispatch();
  useGetUserInfoQuery(undefined, { skip: !token && !getCookie('auth-token') });

  useEffect(() => {
    const savedToken = getCookie('auth-token');
    if (!token && savedToken) {
      dispatch(setToken(savedToken));
    }
    if (!token && !savedToken) {
      if (location.pathname !== '/login' && location.pathname !== '/auth/callback') {
        location.href = '/login';
      }
      return;
    }
    if (location.pathname === '/' || location.pathname === '/login') {
      location.href = '/accounts';
    }
  }, [dispatch, token]);

  return (
    <>
      {children}
    </>
  )

}
